"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class FramedMessage {
    constructor(id, framesNumber, currentFrame, data) {
        this.id = id;
        this.framesNumber = framesNumber;
        this.currentFrame = currentFrame;
        this.data = data;
    }
}
class MessageFramer {
    constructor() {
        this.framedPool = new Map();
        this.framedTimeouts = new Map();
        this.framesTimeoutValue = 5000;
    }
    splitMessageToFrames(message, maxMessageSizeForFrame) {
        return __awaiter(this, void 0, void 0, function* () {
            const framedMessages = [];
            const id = '' + Math.floor(Math.random() * 100000000);
            const messageBlob = new Blob([message]);
            const messageSize = messageBlob.size;
            const framesNumber = Math.ceil(messageSize / maxMessageSizeForFrame);
            const frameSize = Math.floor(messageSize / framesNumber);
            for (let currentFrame = 1; currentFrame <= framesNumber; currentFrame += 1) {
                const frameData = messageBlob.slice((currentFrame - 1) * frameSize, frameSize);
                const framedMessage = new FramedMessage(id, framesNumber, currentFrame, 
                // @ts-ignore
                yield frameData.text());
                framedMessages.push(JSON.stringify(framedMessage));
            }
            return framedMessages;
        });
    }
    prepareIncomingMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            const framedMessage = JSON.parse(message);
            this.framedTimeouts.set(framedMessage.id, setTimeout(() => {
                this.framedPool.delete(framedMessage.id);
            }, this.framesTimeoutValue));
            if (!this.framedPool.has(framedMessage.id)) {
                this.framedPool.set(framedMessage.id, []);
            }
            const frames = this.framedPool.get(framedMessage.id);
            if (frames) {
                frames.push(framedMessage);
                if (framedMessage.framesNumber === frames.length) {
                    const blobParts = [];
                    for (const framedMessage of frames) {
                        blobParts.push(framedMessage.data);
                    }
                    const blob = new Blob(blobParts);
                    // @ts-ignore
                    return yield blob.text();
                }
            }
            // Awaiting other parts
            return undefined;
        });
    }
}
exports.MessageFramer = MessageFramer;
